import { AfterContentInit, Component, Input, NgZone, OnInit } from '@angular/core';
import { InfoEntry } from 'src/app/models/info-entry';
import { map, mergeMap } from 'rxjs/operators';
import { Event } from 'src/models';
import { runInZone } from 'src/utils/runInZone';

@Component({
  selector: 'app-event-token-entry',
  templateUrl: './event-token-entry.component.html',
  styleUrls: ['./event-token-entry.component.scss'],
})
export class EventTokenEntryComponent implements OnInit, AfterContentInit {

  @Input()
  infoEntry: InfoEntry;

  event: Event;

  constructor(private zone: NgZone) {
  }

  ngOnInit(): void {
  }

  ngAfterContentInit(): void {
    if (this.infoEntry != null) {
      const { sdk } = this.infoEntry.environment;
      sdk.getEventLocaleByToken({ eventToken: this.infoEntry.text }).pipe(
        map(resp => resp.eventByToken.defaultLocale),
        mergeMap((locale) => sdk.getEventByToken({ eventToken: this.infoEntry.text, locales: [locale] })),
        runInZone(this.zone),
      ).subscribe((event) => {
        this.event = event.eventByToken as unknown as Event;
      });
    }
  }

}
